import useFetchNoPaging from "#src/hooks/useFetchNoPaging";
import { tagService } from "#src/services/tags";
import { useMemo } from "react";

export const useQueryTag = (workspaceId: string, query: string) => {
  const fetchTagParams = useMemo<
    Parameters<typeof tagService.listTagsNoPaging>
  >(
    () => [workspaceId, { q: query ? query : undefined }],
    [workspaceId, query]
  );

  const { list: tagList } = useFetchNoPaging(
    tagService.listTagsNoPaging,
    fetchTagParams
  );

  return tagList;
};
